<template>
  <div class="json-tree-view">
    <JsonNode 
      ref="rootNode"
      :data="data"
      :keyName="'root'"
      :depth="0"
      :maxDepth="maxDepth"
      :searchQuery="searchQuery"
      :readOnly="readOnly"
      :path="[]"
      @update="handleUpdate"
      @first-match="handleFirstMatch"
    />
  </div>
</template>

<script>
import JsonNode from './JsonTreeViewNode.vue'

export default {
  name: 'JsonTreeView',
  components: {
    JsonNode
  },
  props: {
    data: {
      type: [Object, Array, String, Number, Boolean],
      required: true
    },
    maxDepth: {
      type: Number,
      default: 3
    },
    searchQuery: {
      type: String,
      default: ''
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    searchQuery(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.findFirstMatch()
        })
      }
    }
  },
  methods: {
    handleUpdate(path, newValue) {
      this.$emit('update', this.setValueByPath(this.data, path, newValue))
    },

    setValueByPath(obj, path, value) {
      const result = JSON.parse(JSON.stringify(obj))
      let current = result
      
      for (let i = 0; i < path.length - 1; i++) {
        current = current[path[i]]
      }
      
      if (path.length > 0) {
        current[path[path.length - 1]] = value
      }
      
      return result
    },

    handleFirstMatch(element) {
      this.$emit('first-match', element)
    },

    findFirstMatch() {
      // The first highlighted node will emit first-match event
      if (this.$refs.rootNode) {
        this.$refs.rootNode.checkFirstMatch()
      }
    }
  }
}
</script>

<style scoped>
.json-tree-view {
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', 'Consolas', 'source-code-pro', monospace;
  font-size: 13px;
  line-height: 1.6;
}
</style>
